<template>
    <div class="holiday-hours">
        <div class="td-table-container">
            <table cellspacing="0" cellpadding="0" class="td-table">
                <thead>
                    <tr class="table-header hours-row">
                        <th class="pl-1">Holiday</th>
                        <th class="td-date">Date</th>
                        <th>Regions</th>
                        <th>Hours of Operation</th>
                    </tr>
                </thead>
                <tbody v-if="!isLoading && allCountryHolidays.length > 0">
                    <template v-for="(holiday, index) in allCountryHolidays" :key="holiday.id">
                        <tr class="table-row hours-row" v-if="holiday.id in holidaysModel">
                            <td class="pl-75">
                                <strong class="td-text-secondary">{{ holiday.name }}</strong>
                            </td>

                            <td class="td-date">
                                <strong class="show-mobile">Date:</strong>
                                {{dateDisplay(holiday.displayDate)}}
                            </td>
                            <td class="regions">
                                <strong class="show-mobile">Regions: </strong>
                                <span v-if="holiday.regionCodes.length > 0">{{getRegions(holiday.regionCodes)}} (<span class="td-text-subdued">{{getCountries(holiday.countryCodes)}}</span>)</span>
                                <span v-else class="td-badge secondary icon-left"><icon name="faGifts" type="solid"></icon>National Holiday</span>
                            </td>
                            <td class="pr-1 td-text-right table-actions">
                                <div class="td-radio background ml-0">
                                    <label :for="'type-closed' + holiday.id">
                                        <input type="radio"
                                               v-model="holidaysModel[holiday.id]"
                                               :id="'type-closed' + holiday.id"
                                               :name="'type-closed' + holiday.id"
                                               :value="HoursOfOperationHolidaysCondition.Closed"
                                               @change="updateHoursType" />
                                        <span>Closed</span>
                                    </label>
                                    <label :for="'type-limited' + holiday.id">
                                        <input type="radio"
                                               v-model="holidaysModel[holiday.id]"
                                               :name="'type-limited' + holiday.id"
                                               :id="'type-limited' + holiday.id"
                                               @change="updateHoursType"
                                               :value="HoursOfOperationHolidaysCondition.LimitedServices" />
                                        <span>Limited Service</span>
                                    </label>
                                    <label :for="'type-regular' + holiday.id">
                                        <input type="radio"
                                               :value="HoursOfOperationHolidaysCondition.RegularHours"
                                               v-model="holidaysModel[holiday.id]"
                                               @change="updateHoursType"
                                               :id="'type-regular' + holiday.id"
                                               :name="'type-regular' + holiday.id" />
                                        <span>Regular Hours</span>
                                    </label>
                                </div>
                            </td>
                        </tr>

                    </template>
                </tbody>
                <tbody v-if="isLoading">
                    <tr><th colspan="4"><div class="loading"><icon name="faSpinner" type="solid" spin></icon></div></th></tr>
                </tbody>
            </table>
        </div>  
    </div>
</template>
<script>
    import script from './HolidayHours';
    export default script;</script>

<style lang="less">
    @import "./HolidayHours.less";
</style>